/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SelectTemplate.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { componentStyle } from "../../../../config/appTheme";
import AddButtonV2 from "../../../../components/customComponentsV2/common/button/AddButtonV2";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

function SelectTemplate({
  heading,
  onClickAdd,
  content,
  enableEdit,
  addButtonDisabled,
  isRequired = false,
  showSmartMatch = false, // NEW
  onSmartMatchClick = () => {}, // NEW
  disableSmartMatch = false,
}) {
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#ffffff",
        minHeight: "50px",
        p: 1,
      }}
    >
      <Grid container alignItems="center">
        <Grid item sm={10}>
          <Typography
            sx={{
              ...componentStyle.font.cardHeadder,
              textAlign: "left",
              p: 1,
              gap: 1,
            }}
          >
            {`${heading}:`}
            {isRequired && <span style={{ color: "red" }}>*</span>}
          </Typography>
        </Grid>
        <Grid item sm={2}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 1,
              p: 1,
            }}
          >
            {showSmartMatch && (
              <IconButton
                size="small"
                onClick={onSmartMatchClick}
                aria-label="Smart Match"
                disabled={disableSmartMatch}
              >
                <AutoAwesomeIcon
                  fontSize="small"
                  sx={{
                    fontSize: "15px",
                    color: disableSmartMatch ? "rgba(0, 0, 0, 0.3)" : "black",
                  }}
                />
              </IconButton>
            )}
            {enableEdit ? (
              <BorderColorIcon
                onClick={onClickAdd}
                sx={{ fontSize: "14px", cursor: "pointer" }}
              />
            ) : (
              <AddButtonV2
                handleOnClick={onClickAdd}
                disabled={addButtonDisabled}
              />
            )}
          </Box>
        </Grid>
      </Grid>
      <Grid item sm={12}>
        {enableEdit ? <Box>{content}</Box> : null}
      </Grid>
    </Box>
  );
}

SelectTemplate.propTypes = {
  heading: PropTypes.node,
  onClickAdd: PropTypes.func,
  content: PropTypes.node,
  enableEdit: PropTypes.bool,
  addButtonDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  showSmartMatch: PropTypes.bool,
  onSmartMatchClick: PropTypes.func,
  disableSmartMatch: PropTypes.bool,
};

export default SelectTemplate;
